"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chevron_small_left = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const chevron_small_left = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'chevron-small-left-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.5303 6.08869C12.8232 6.38158 12.8232 6.85646 12.5303 7.14935L9.06066 10.619L12.5303 14.0887C12.8232 14.3816 12.8232 14.8565 12.5303 15.1493C12.2374 15.4422 11.7626 15.4422 11.4697 15.1493L7.46967 11.1493C7.32902 11.0087 7.25 10.8179 7.25 10.619C7.25 10.4201 7.32902 10.2293 7.46967 10.0887L11.4697 6.08869C11.7626 5.7958 12.2374 5.7958 12.5303 6.08869Z', fill: '#4B5563' })));
};
exports.chevron_small_left = chevron_small_left;
